import {lazy} from "react";
import { constants } from "../constants/constants";
import SearchBuilding from "../../tenants/map/searchBuilding";
import HealthCheck from "../healthCheck";
const TermsOfService = lazy(() => import("../../common/static_pages/terms_of_service/termsOfService2"));
const Privacy = lazy(() => import("../../common/static_pages/privacy/privacy2"));
const ManualComponent = lazy(() => import("../../common/manual/manual"));
const TenantProfileModule =  lazy(() => import("../../tenants/profile/index"));

export const GeneralRoutes = [
    {path: `/`, component: SearchBuilding, exact: true},// * home page is search*/
    {path: `/${constants.pages.healthCheckUrl}`, component: HealthCheck, exact: true},
    {path: `/${constants.pages.termsOfServiceUrl}`, component: TermsOfService, exact: true}, // deprecated, used pdf from s3
    {path: `/${constants.pages.privacyUrl}`, component: Privacy, exact: true}, // deprecated, used pdf from s3
    {path: `/${constants.pages.bankChargeUrl}`, component: ManualComponent, exact: true, props: { mode: 'tenant' }},
    {path: `/${constants.pages.tenantProfile}`, component: TenantProfileModule, exact: false, newFlowFooter: true, removeHeader: true },
]


